import {
  IsBoolean,
  IsDate,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Max,
  Min,
} from 'class-validator';

/**
 * One training condition as returned by the training condition search. The field set is the
 * contract the former search index exposed, kept intact for the admin client.
 */
export class TrainingLesionIndexDataDto {
  @IsUUID()
  id!: string;

  @IsOptional()
  @IsNumber()
  @Min(0)
  patientAgeYears?: number;

  @IsUUID()
  patientId!: string;

  @IsOptional()
  @IsUUID()
  skinTypeId?: string;

  @IsOptional()
  @IsString()
  skinTypeName?: string;

  @IsOptional()
  @IsNumber()
  @Min(0)
  dermoscopyFollowTimeMonths?: number;

  @IsBoolean()
  histopathologyConducted!: boolean;

  @IsBoolean()
  sentinelNodeBiopsyConducted!: boolean;

  @IsOptional()
  @IsBoolean()
  recurrence?: boolean;

  @IsOptional()
  @IsNumber()
  @Min(0)
  recurrenceTimeMonths?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  totalTimeOfFollowUpMonths?: number;

  @IsBoolean()
  mcq!: boolean;

  @IsUUID()
  statusId!: string;

  @IsString()
  statusName!: string;

  @IsOptional()
  @IsUUID()
  locationId?: string;

  @IsOptional()
  @IsString()
  locationName?: string;

  @IsUUID()
  diagnosisId!: string;

  @IsString()
  diagnosisName!: string;

  @IsOptional()
  @IsUUID()
  secondaryDiagnosisId?: string;

  @IsOptional()
  @IsString()
  secondaryDiagnosisName?: string;

  @IsOptional()
  @IsUUID()
  recurrenceLocationId?: string;

  @IsOptional()
  @IsString()
  recurrenceLocationName?: string;

  @IsUUID()
  clinicalImageId!: string;

  @IsUUID()
  dermoscopicImageId!: string;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @Max(1)
  dermoscopicImageDifficultyIndex?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @Max(1)
  dermoscopicImageAiDifficultyIndex?: number;

  @IsNumber()
  @Min(0)
  assessmentsCount!: number;

  // If true, there exists an approved annotation
  // If false, there exists an annotation that is not approved
  // If null, there exists no annotations
  @IsOptional()
  @IsBoolean()
  hasApprovedAnnotation?: boolean;

  // Is the training skin condition skipped for annotations.
  // Annotator has skipped the skin condition because he/she lacks knowledge or wants to go through it with a supervisor/reviewer.
  @IsOptional()
  @IsBoolean()
  isSkipped?: boolean;

  // If true, there exists feedback on the annotation and it has been read by the annotator.
  // If false, there exists unread feedback
  // If null, there exists no feedback
  @IsOptional()
  @IsBoolean()
  feedbackMarkedAsRead?: boolean;

  // If true, there exists feedback with requested changes for the annotation
  // If false, there exists feedback, but no changes are required, meaning approved but with a comment
  // If null, there exists no feedback
  @IsOptional()
  @IsBoolean()
  annotationChangeRequested?: boolean | null;

  @IsNumber()
  randOrdering!: number;

  @IsDate()
  created!: Date;

  @IsNumber()
  @Min(0)
  annotationRequestsCount!: number;
}
